import * as React from 'react';
import { Button } from 'ui';
import { OAuthProviderEnum } from '../../../utils/types/eunms';
import { cn } from '@utils';

type SSOProviderButtonProps = {
	provider: OAuthProviderEnum;
	handleSSO: (provider: OAuthProviderEnum) => void;
	className?: string;
	'data-testid'?: string;
	children: React.ReactNode;
};

/**
 * SSO chrome that preserves the bordered pill look (auth icon variant),
 * since ui Button `icon` is a square icon-only control.
 */
export const SSOProviderButton: React.FC<SSOProviderButtonProps> = ({
	provider,
	handleSSO,
	className,
	children,
	...rest
}) => {
	return (
		<Button
			variant="secondaryBorder"
			type="button"
			onClick={() => handleSSO(provider)}
			className={cn('h-[50px] w-full rounded-3xl border-borderPrimary', className)}
			{...rest}
		>
			{children}
		</Button>
	);
};
